import { FC } from 'react';
import { Texts } from '../Texts';

/* Styles */
import styles from './Checkbox.module.scss';
import { CheckmarkDIV } from '../CheckmarkDIV/CheckmarkDIV';

interface CheckboxProps {
  className?: string;
  id: string;
  label: string;
  name?: string;
  type: 'checkbox' | 'radio';
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Checkbox: FC<CheckboxProps> = ({
  className = '',
  id,
  label,
  name,
  type,
  disabled = false,
  onChange,
}) => {
  return (
    <label
      id={`checkbox_${id}`}
      htmlFor={id}
      className={`${styles.checkbox} ${className}`}
    >
      <input
        id={id}
        className={styles.checkbox_input}
        name={name}
        type={type}
        disabled={disabled}
        aria-label={label}
        onChange={onChange}
      />
      <div className={styles.body} aria-hidden={true}>
        <CheckmarkDIV />
      </div>

      <div aria-hidden={true} className={styles.label_wrapper}>
        <Texts className={styles.label}>{label}</Texts>
      </div>
    </label>
  );
};
